import { render, staticRenderFns } from "./ContextMenu.vue?vue&type=template&id=f3ca35ce&scoped=true"
import script from "./ContextMenu.vue?vue&type=script&lang=ts"
export * from "./ContextMenu.vue?vue&type=script&lang=ts"
import style0 from "./ContextMenu.vue?vue&type=style&index=0&id=f3ca35ce&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f3ca35ce",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/v2.online.dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f3ca35ce')) {
      api.createRecord('f3ca35ce', component.options)
    } else {
      api.reload('f3ca35ce', component.options)
    }
    module.hot.accept("./ContextMenu.vue?vue&type=template&id=f3ca35ce&scoped=true", function () {
      api.rerender('f3ca35ce', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/browse/ContextMenu.vue"
export default component.exports